<ng-template #content>
  @if (ctx; as ctx) {
    <div class="modal-header">
      <h5 class="modal-title">
        <i class="fa fa-history me-2 text-primary"></i>
        Test Log
      </h5>
      <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
    </div>
    <div class="modal-body test-log-body">
      <p class="test-log-test-title mb-3">
        <strong>{{ ctx.testTitle }}</strong>
      </p>
      @if (ctx.isLoading) {
        <div class="test-log-loading text-center py-4">
          <span class="text-muted">Loading...</span>
        </div>
      }
      @if (!ctx.isLoading) {
        @if (ctx.logs.length > 0) {
          <table class="test-log-table table table-bordered table-hover">
            <thead class="table-light">
              <tr>
                <th>Author</th>
                <th>Date / Time</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              @for (log of getPagedLogs(ctx.logs); track log; let i = $index) {
                <tr>
                  <td>{{ log.author }}</td>
                  <td>{{ log.dateTime | date:'dd/MM/yyyy HH:mm' }}</td>
                  <td>
                    <span [class]="'log-status-badge ' + getLogStatusClass(log.status)">
                      {{ getLogStatusLabel(log.status) }}
                    </span>
                  </td>
                </tr>
                @if (log.status === 'FAILED' && (log.issueDescription || log.attachments.length > 0)) {
                  <tr class="fail-details-row">
                    <td colspan="3">
                      <div class="fail-details-box">
                        <span class="fail-details-label"><i class="fa fa-exclamation-triangle me-1"></i>Fail details</span>
                        @for (attachment of log.attachments; track attachment) {
                          <div class="fail-details-attachment">
                            <span class="fail-details-attachment-name">
                              <i class="fa fa-paperclip me-1"></i>{{ attachment.fileNameOriginal }}
                            </span>
                            <button type="button" class="btn btn-sm btn-outline-primary"
                              title="Download attachment"
                              (click)="downloadAttachment(log, attachment)">
                              <i class="fa fa-download me-1"></i>
                              Download
                            </button>
                          </div>
                        }
                        @if (log.issueDescription && log.attachments.length > 0) {
                          <hr class="fail-details-separator">
                        }
                        @if (log.issueDescription) {
                          <p class="fail-details-text mb-0"
                            #descriptionText
                            [attr.data-log-index]="i"
                          [class.expanded]="isDescriptionExpanded(i)">{{ log.issueDescription }}</p>
                          @if (isDescriptionOverflowing(i)) {
                            <a class="fail-details-toggle" (click)="toggleDescription(i)">
                              {{ isDescriptionExpanded(i) ? 'Show less' : 'Show more' }}
                            </a>
                          }
                        }
                      </div>
                    </td>
                  </tr>
                }
              }
            </tbody>
          </table>
        } @else {
          <p class="text-center text-muted fst-italic py-3">No log entries available for this test.</p>
        }
      }
    </div>
    @if (!ctx.isLoading && ctx.logs.length > pageSize) {
      <div class="modal-footer">
        <div class="dataTables_paginate paging_simple_numbers">
          <ul class="pagination pagination-sm justify-content-end mb-0 primary-pagination">
            <li class="paginate_button page-item" [ngClass]="{ 'disabled': currentPage === 1 }">
              <a class="page-link" (click)="goToPage(currentPage - 1, ctx.logs)">Back</a>
            </li>
            @for (p of pageRange(ctx.logs); track p) {
              <li class="paginate_button page-item" [ngClass]="{ 'active': p === currentPage }">
                <a class="page-link" (click)="goToPage(p, ctx.logs)">{{ p }}</a>
              </li>
            }
            <li class="paginate_button page-item" [ngClass]="{ 'disabled': currentPage === totalPages(ctx.logs) }">
              <a class="page-link" (click)="goToPage(currentPage + 1, ctx.logs)">Forward</a>
            </li>
          </ul>
        </div>
      </div>
    }
  }
</ng-template>
